/**
 * Real-Time Connection Composable
 *
 * Manages the Socket.IO connection lifecycle tied to auth state.
 * Provides global connection status for UI indicators.
 * Should be initialized once in the app layout.
 */

import { watch, onUnmounted } from 'vue'
import { useSocket } from './useSocket'
import { useAuthStore } from '@/stores/auth'

export function useRealtimeConnection() {
  const { connectionState, isConnected, connect, disconnect } = useSocket()
  const authStore = useAuthStore()

  // Connect when authenticated, disconnect when not
  const stopWatch = watch(
    () => authStore.isAuthenticated,
    (authenticated) => {
      if (authenticated) {
        connect()
      } else {
        disconnect()
      }
    },
    { immediate: true }
  )

  onUnmounted(() => {
    stopWatch()
  })

  return {
    connectionState,
    isConnected,
  }
}
